import './menu.js';
import './alert.js';
import './productbox-slider.js';

let lazyLoad = null

/**
 * index category
 */
const ready = (callback) => {
    if (document.readyState !== "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};

const lazyLoadUpdate = () => {
    lazyLoad?.update();
}

const filterInit = async () => {
    let {Filter} = await import('./filter');
    new Filter(
        '/api/v1/filter',
        'productFilter-link',
        'productFilter-select',
        'productFilter-price',
        'productFilter-filter',
        'productFilter-products',
        'productFilter-orderer',
        'productFilter-link--orderer',
        'productFilter-count',
        'productFilter-pager',
        'productFilter-pagerBottom',
        'productFilter-link--pager',
        'productFilter-showMore',
        'productFilter-showMoreWrapper',
        'productFilter-nextLink',
        'productFilter-not-found',
        'js-site-backdrop',
        'productFilter-selectedFilter',
        'productFilter-clearSelected',
        'productFilter-clear',
        'productFilter-settings',
        'productFilter-h1',
        'productFilter-description',
        'productFilter-additionalDescription',
        'productFilter-shortDescription',
        () => lazyLoadUpdate()
    );
}

ready(async () => {
    let {initLazyLoad} = await import('./common/lazyload');
    lazyLoad = await initLazyLoad();

    let {headRoomInit} = await import('./common/headroom');
    headRoomInit();

    let {autocompleteHoverInit, autocompleteInit} = await import('./common/autocomplete');
    await autocompleteInit();
    await autocompleteHoverInit();
    let {modalInit} = await import('./common/modal');
    const {filterLinksUrl} = await import('./filterLinksUrl.js');
    filterLinksUrl().then(async () => {
        filterInit()
        modalInit()
    });

    const {loadProducts} = await import('./common/product/products');
    loadProducts(() => lazyLoadUpdate());

    const {loadAdvisoryLinks} = await import('./common/advisory-links')
    loadAdvisoryLinks(() => lazyLoadUpdate())

    const {loadKeyBrands} = await import('./common/key-brands');
    loadKeyBrands(async () => {
        lazyLoadUpdate()
        const { glideBrandsInit } = await import('./common/glide/glide-brands');
        glideBrandsInit();
    })

    const {loadCategoryTree} = await import('./common/category-tree');
    loadCategoryTree(() => lazyLoadUpdate())

    let {truncateLinesInit} = await import('./common/truncate-lines');
    truncateLinesInit();

    let {glideProductListSmallInit} = await import('./common/glide/glide-product-list-small');
    glideProductListSmallInit();

    let {formControllInit} = await import('./common/form-controll');
    formControllInit();

    let {stickFilterButtonInit} = await import('./common/stick-filter-button');
    stickFilterButtonInit();

    let {drowpdowOverlayInit} = await import('./common/dropdown-overlay');
    drowpdowOverlayInit();
    let {drowpdowHoverInit} = await import('./common/dropdown-hover')
    drowpdowHoverInit();

    let {searchBoxFocusInit} = await import('./common/search-box');
    searchBoxFocusInit();

    let {siteBarAlertInit} = await import('./common/site-bar-alert');
    siteBarAlertInit();

    let {jsSubmenuInit} = await import('./common/js-submenu.js');
    jsSubmenuInit(() => lazyLoadUpdate());

    let {descriptionPromoBlocksDescriptionInit, glidePromoBlockDescriptionInit} = await import('./promoblocks');
    descriptionPromoBlocksDescriptionInit();
    glidePromoBlockDescriptionInit();
    let {collapseInit} = await import('./common/collapse');
    collapseInit();
    modalInit();
    const {dropdownInit} = await import('./common/dropdown');
    dropdownInit();

    const {initNewsletter} = await import('./common/newsletter');
    initNewsletter();
    const {initYoutubeVideo} = await import('./common/yt-video');
    initYoutubeVideo();
    const {removeSearchParamInUrlAndHistory} = await import('./common/remove-search-param')
    setTimeout(() => removeSearchParamInUrlAndHistory('_fid'), 200);

    const {initPaddingTopSiteContent} = await import('./common/site-content');
    initPaddingTopSiteContent();
});